import React, { useContext, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ThemeContext } from './ThemeProvider';
import { SidebarCollapsedContext } from './SidebarCollapsed';
import './NavMenu.css';

const NavMenuItem = ({ to, label, children }) => {
    const location = useLocation();
    const { collapsed } = useContext(SidebarCollapsedContext);

    let isActive = false;
    if (to === '/') {
        isActive = location.pathname === '/';
    } else {
        isActive = location.pathname.startsWith(to) &&
            (location.pathname.length === to.length ||
             location.pathname[to.length] === '/' ||
             location.pathname[to.length] === '?');
    }

    return (
        <li className={isActive ? 'nav-item active' : 'nav-item'}>
            <Link className="nav-link" to={to} title={collapsed ? label : ''}>{children}</Link>
        </li>
    );
};

export default () => {
    const { theme, toggleTheme } = useContext(ThemeContext);
    const { collapsed, toggle: toggleCollapsed } = useContext(SidebarCollapsedContext);

    // Persist collapsed state in localStorage
    useEffect(() => {
        try {
            localStorage.setItem('solarapp-nav-collapsed', String(collapsed));
        } catch { /* ignore */ }
    }, [collapsed]);

    return (
        <div className={`sidebar-navbar ${collapsed ? 'collapsed' : ''}`}>
            {/* Brand row: app name left, toggles right */}
            <div className="navbar-brand-row">
                <Link className="navbar-brand-link" to="/">
                    <i className="bi bi-solar-panel" />
                    {!collapsed && <span>solarapp</span>}
                </Link>
                <div className="brand-actions">
                    {/* Dark Mode Toggle */}
                    <button className="theme-toggle-icon" onClick={toggleTheme} title={theme === 'dark' ? 'Light Mode' : 'Dark Mode'}>
                        <i className={`bi ${theme === 'dark' ? 'bi-sun-fill' : 'bi-moon-fill'}`} />
                    </button>
                    {/* Collapse Toggle */}
                    <button className="collapse-toggle-icon" onClick={toggleCollapsed} title={collapsed ? 'Navigation aufklappen' : 'Navigation einklappen'}>
                        <i className={`bi bi-chevron-${collapsed ? 'bar-right' : 'bar-left'}`} />
                    </button>
                </div>
            </div>
            <ul className="nav flex-column">
                <NavMenuItem to={'/'} label="Kurz-Überblick">
                    <i className="bi bi-eye" /> {!collapsed && 'Kurz-Überblick'}
                </NavMenuItem>
                <NavMenuItem to={'/leistung'} label="Leistungen">
                    <i className="bi bi-lightning-charge-fill" /> {!collapsed && 'Leistungen'}
                </NavMenuItem>
                <NavMenuItem to={'/bellcurve'} label="Glockenkurve">
                    <i className="bi bi-sunrise-fill" /> {!collapsed && 'Glockenkurve'}
                </NavMenuItem>
                <NavMenuItem to={'/powermaxconsumptiondaily'} label="Max-Stromverbrauch">
                    <i className="bi bi-speedometer" /> {!collapsed && 'Max-Stromverbrauch'}
                </NavMenuItem>
                <NavMenuItem to={'/vorhersage'} label="Vorhersage">
                    <i className="bi bi-cloud-sun" /> {!collapsed && 'Vorhersage'}
                </NavMenuItem>
                <NavMenuItem to={'/ist'} label="Monatsertrag">
                    <i className="bi bi-bar-chart-line" /> {!collapsed && 'Monatsertrag'}
                </NavMenuItem>
                <NavMenuItem to={'/istAllYears'} label="Jahresertrag">
                    <i className="bi bi-bar-chart-line-fill" /> {!collapsed && 'Jahresertrag'}
                </NavMenuItem>
                <NavMenuItem to={'/einnahmen'} label="Einnahmen">
                    <i className="bi bi-cash-stack" /> {!collapsed && 'Einnahmen'}
                </NavMenuItem>
                <NavMenuItem to={'/strom'} label="Stromverbrauch">
                    <i className="bi bi-graph-down-arrow" /> {!collapsed && 'Stromverbrauch'}
                </NavMenuItem>
                <NavMenuItem to={'/durchschnitt'} label="Durchschnitt">
                    <i className="bi bi-bar-chart" /> {!collapsed && 'Durchschnitt'}
                </NavMenuItem>
                <NavMenuItem to={'/anlage'} label="Anlage">
                    <i className="bi bi-gear" /> {!collapsed && 'Anlage'}
                </NavMenuItem>
                <NavMenuItem to={'/wr'} label="Wechselrichter">
                    <i className="bi bi-cpu" /> {!collapsed && 'Wechselrichter'}
                </NavMenuItem>
                <NavMenuItem to={'/yearstromgesamt'} label="Jahr">
                    <i className="bi bi-calendar3" /> {!collapsed && 'Jahr'}
                </NavMenuItem>
                <NavMenuItem to={'/evu_pv'} label="EVU/PV">
                    <i className="bi bi-arrow-left-right" /> {!collapsed && 'EVU/PV'}
                </NavMenuItem>
                <NavMenuItem to={'/verbrauch'} label="∑ Jahr-Verbrauchsanalyse">
                    <i className="bi bi-pie-chart" /> {!collapsed && '∑ Jahr-Verbrauchsanalyse'}
                </NavMenuItem>
                <NavMenuItem to={'/finanz'} label="Finanzuebersicht">
                    <i className="bi bi-wallet2" /> {!collapsed && 'Finanzuebersicht'}
                </NavMenuItem>
                <NavMenuItem to={'/abschlag'} label="EVU Abschlaege">
                    <i className="bi bi-calculator" /> {!collapsed && 'EVU Abschlaege'}
                </NavMenuItem>
                <NavMenuItem to={'/pv-jahresvergleich'} label="Jahresvergleich">
                    <i className="bi bi-graph-up-arrow" /> {!collapsed && 'Jahresvergleich'}
                </NavMenuItem>
                <NavMenuItem to={'/strombezug-analyse'} label="Strombezug-Analyse">
                    <i className="bi bi-plug-fill" /> {!collapsed && 'Strombezug-Analyse'}
                </NavMenuItem>
            </ul>
        </div>
    );
};
